module.exports = __webpack_public_path__ + "media/images/logo-28f7e31d41f353b3aaff1236c7108479.png";